import { render, staticRenderFns } from "./ClinicalDataPage.vue?vue&type=template&id=668a9770&"
import script from "./ClinicalDataPage.vue?vue&type=script&lang=js&"
export * from "./ClinicalDataPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports